var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlashlight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.303 11.965a.42.42 0 0 1-.199-.185.45.45 0 0 1-.047-.273l.746-5.079H2.822a.4.4 0 0 1-.33-.158.44.44 0 0 1-.08-.37L3.641.33a.43.43 0 0 1 .15-.242.4.4 0 0 1 .26-.088h4.103a.4.4 0 0 1 .32.158.44.44 0 0 1 .082.364l-.71 3.335h1.949q.117 0 .218.064a.4.4 0 0 1 .151.176.45.45 0 0 1-.045.428l-5.333 7.286a.4.4 0 0 1-.14.135.4.4 0 0 1-.184.053.4.4 0 0 1-.16-.034Z"
})));
export default SvgFlashlight;